document.addEventListener("DOMContentLoaded", function () {

	document.querySelectorAll('.question-modal').forEach(button => {
		button.addEventListener('click', () => {
			const modal = document.getElementById('question-modal');
			// console.log(1);
			modal.classList.toggle('hidden');
		});
	});

	document.querySelectorAll('.maintenance-modal').forEach(button => {
		button.addEventListener('click', () => {
			const modal = document.getElementById('hippo-maintenance-modal');
			// console.log(2);
			modal.classList.toggle('hidden');
		});
	});


	document.querySelectorAll('.enquire-modal').forEach(button => {
		button.addEventListener('click', () => {
			const modal = document.getElementById('get-your-personalised-quote-modal');
			// console.log(3);
			modal.classList.toggle('hidden');
		});
	});

	

	document.querySelectorAll('.call-us-modal').forEach(button => {
		button.addEventListener('click', () => {
			const modal = document.getElementById('call-us-modal');
			// console.log(4);
			modal.classList.toggle('hidden');
		});
	});


	document.querySelectorAll('.close-modal').forEach(button => {
		button.addEventListener('click', () => {
			const modalId = button.dataset.modalName;
			const modal = document.getElementById(modalId);
			// console.log(modalId);
			if (modal) {
				modal.classList.add('hidden');
			}
		});
	});

	document.querySelectorAll('.question-modal-1').forEach(button => {
		button.addEventListener('click', () => {
			const modal = document.getElementById('question-modal');
			// console.log(1);
			if (modal) {
				modal.classList.toggle('hidden');
			}
		});
	});

	document.querySelectorAll('.question-modal-2').forEach(button => {
		button.addEventListener('click', () => {
			const modal = document.getElementById('question-modal-2');
			// console.log(2);
			if (modal) {
				modal.classList.toggle('hidden');
			}
		});
	});

	document.querySelectorAll('.question-modal-3').forEach(button => {
		button.addEventListener('click', () => {
			const modal = document.getElementById('question-modal-3');
			// console.log(3);
			if (modal) {
				modal.classList.toggle('hidden');
			}
		});
	});

	document.querySelectorAll('.question-modal-4').forEach(button => {
		button.addEventListener('click', () => {
			const modal = document.getElementById('question-modal-4');
			// console.log(3);
			if (modal) {
				modal.classList.toggle('hidden');
			}
		});
	});
	document.querySelectorAll('.question-modal-5').forEach(button => {
		button.addEventListener('click', () => {
			const modal = document.getElementById('question-modal-5');
			// console.log(3);
			if (modal) {
				modal.classList.toggle('hidden');
			}
		});
	});
/*'#personalised-quote-modal'
'#hippo-maintenance-modal'
'#question-modal'
'#call-us-modal'
'#get-your-personalised-quote-modal'
*/

});